import { useParams, useNavigate } from 'react-router-dom';
import { Card, Spin } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import ReferralForm from '../components/ReferralForm';
import { useReferralDetails } from '../hooks/useReferralQueries';
import { useUpdateReferral } from '../hooks/useReferralMutations';

export default function ReferralEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data, isLoading: loadingDetails } = useReferralDetails(id);
  const mutation = useUpdateReferral();
  const handleSubmit = (formData: any) => { (mutation.mutate as any)({ id, data: formData }, { onSuccess: () => navigate('/referrals') }); };
  if (loadingDetails) return <Spin style={{ display: 'block', margin: '80px auto' }} />;
  return (
    <div>
      <PageHeader back title={t('referrals.editTitle')} subtitle={`${t('common.editing')}: ${data?.nameEn || ''}`} />
      <Card><ReferralForm initialData={data} onSubmit={handleSubmit} isLoading={mutation.isPending} /></Card>
    </div>
  );
}
